<template>
  <div class="small-program-list">
    <div class="header">
      <search-line @on-search="onSearch" />
      <muti-upload
        ref="upload"
        :accept="accept"
        :limit-size="20"
        file-path="material/plain/file"
        @finish="onUploadFinish"
      />
      <mk-popover
        v-model="selectTypeShow"
        placement="bottom"
        title=""
        width="0"
        trigger="click"
        popper-class="small-program-list-select-type-popover"
      >
        <mk-button-biz
          slot="reference"
          class="add-select-btn"
          type="primary"
          icon="el-icon-plus"
          width="102px"
        >
          新增
        </mk-button-biz>
        <ul>
          <li
            v-for="(item,index) in selectTypeList"
            :key="index"
            @click="add(index)"
          >
            {{ item }}
          </li>
        </ul>
      </mk-popover>
    </div>
    <!-- 侧边栏新增小程序素材 -->
    <ordinary-material-select
      v-if="visible"
      :show="visible"
      @cancel="cancel"
      @confirm="confirm"
    />
    <div
      class="infinite-scroll-wrapper"
    >
      <infinite-scroll
        ref="infiniteScroll"
        class="infinite-scroll"
        :api="api"
        :page-size="30"
        @on-load-over="onLoadOver"
      >
        <item
          v-for="(item,index) in list"
          :key="item._id+item.status+item.updateTime"
          :item-data="item"
          :other-api="otherApi"
          @edit-item="editItem(index, item.sourceType)"
          @delete-item="deleteItem(index)"
          @update-item="itemData=>updateItem(itemData,index)"
        />
      </infinite-scroll>
      <!-- <div v-if="list.length === 0">
        暂无数据
      </div> -->
      <no-data v-if="list.length === 0" />
    </div>
  </div>
</template>
<script>
import InfiniteScroll from '@components/infinite-scroll'
import item from './components/common/item'
import searchLine from './components/common/search-line'
import mutiUpload from './components/common/muti-upload'
import ordinaryMaterialSelect from './components/common/ordinary-material-select'
import { MKMATERIALSVC } from '@api'

import noData from '@components/no-data/index'
export default {
  name: 'SmallProgramList',
  components: {
    InfiniteScroll,
    item,
    searchLine,
    mutiUpload,
    ordinaryMaterialSelect,
    noData
  },
  data () {
    return {
      type: 'article',
      list: [],
      api: {
        // 接口方法：必须为Promise对象
        promiseFun: MKMATERIALSVC.MiniMaterialApi.miniMaterialListPost,
        // 接口参数；分页参数已经放在infiniteScroll组件里面了，所以这块写除了分页的其他参数
        params: {
          showTags: true
        }
      },
      // 其他接口
      otherApi: {
        delete: MKMATERIALSVC.MiniMaterialApi.miniMaterialDelete,
        publish: MKMATERIALSVC.MiniMaterialApi.miniMaterialCreatePost,
        update: MKMATERIALSVC.MiniMaterialApi.miniMaterialCreatePost,
        find: MKMATERIALSVC.MiniMaterialApi.miniMaterialDetailGet,
        statistics: MKMATERIALSVC.MiniMaterialreportApi.reportMiniMaterialFindStatisticsGet
      },
      selectTypeShow: false,
      selectTypeList: ['本地上传', '从文件中选择'],
      accept: '.doc,.docx,.xlx,.xls,.xlsx,.pdf,.ppt,.pptx,.jpg,.png,.jpeg,.gif,.bmp,.mp3,.wma,.wav,.amr,.m4a,.mp4',
      // 侧边栏
      visible: false
    }
  },
  methods: {
    onLoadOver (list) {
      this.list.push(...list)
    },
    editItem () {},
    deleteItem (index) {
      this.list.splice(index, 1)
    },
    async updateItem (itemData, index) {
      if (itemData._id) {
        // 通过接口，重新获取当前id的最新数据
        const res = await this.otherApi.find({
          _id: itemData._id
        })
        if (res.success) {
          // 将最新数据放到对应下标的dataList中
          this.$set(this.list, index, res.data)
        }
      } else {
        // 不通过接口，更新某个数据
        // 主要针对于状态的改变
        const newItemData = { ...this.list[index], ...itemData }
        this.$set(this.list, index, newItemData)
      }
    },
    onSearch (searchParams) {
      this.list = []
      this.$refs.infiniteScroll.resetPage(searchParams)
    },
    confirm () {
      this.visible = false
      this.list = []
      this.$refs.infiniteScroll.resetPage({
        showTags: true
      })
    },
    cancel () {
      this.visible = false
    },
    // 新增
    add (index) {
      if (index) {
        this.visible = true
      } else {
        this.$refs.upload.upload()
      }
    },
    onUploadFinish () {
      this.list = []
      this.$refs.infiniteScroll.resetPage({
        showTags: true
      })
    }
  }
}
</script>
<style lang="scss">
body {
  .small-program-list-select-type-popover {
    padding: 0;
    min-width: 102px;

    ul {
      padding-bottom: 4px;

      li {
        line-height: 36px;
        font-size: 13px;
        cursor: pointer;
        color: #262626;
        // border-bottom: 1px solid #e8e8e8;
        text-align: center;

        &:hover {
          background-color: #f7f7f7;
        }
      }

      li:last-child {
        border: none;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
  .small-program-list {
    display: flex;
    flex-direction: column;
    position: relative;
    height: 100%;
    overflow: hidden;

    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-shrink: 0;

      .add-select-btn {
        margin-right: 20px;
      }
    }

    .infinite-scroll-wrapper {
      flex: 1;
      overflow: hidden;
    }

    .infinite-scroll {
      width: calc(100% - 20px);
      margin-left: 20px;
      display: flex;
      flex-wrap: wrap;
      max-height: 100%;
      overflow-y: auto;

      .item {
        margin: 0 20px 20px 0;
      }
    }
  }
</style>
